import React from 'react';
import { Container } from 'react-bootstrap';
import './gizlilikPolitikasi.css';

const GizlilikPolitikasi = () => {
  return (
    <Container className="gizlilik-politikasi-container py-5">
      <h1 className="page-title mb-4">Gizlilik Politikası</h1>
      
      <div className="content">
        <p className="secret-text">
          Atatürk Kültür Merkezi Başkanlığınca hazırlanan ve dijital ortamda erişime açılmış olan Türk Mutfak Kültürü Atlası ve Ansiklopedisi internet sitesine hoş geldiniz. 
          Bu bölüm, Türk Mutfak Kültürü Atlası ve Ansiklopedisi internet sitesi ziyaret ve kullanım koşullarını içermektedir. Lütfen siteyi kullanmadan önce kullanım koşullarını dikkatlice okuyunuz.
        </p>

        <p>
          Bu İnternet sitesi (Bundan böyle "site" olarak anılacaktır.) içeriğinde yer alan tüm eserler (yazı, resim, görüntü, fotoğraf, video, müzik vb.) 
          Atatürk Kültür Merkezi Başkanlığına (Bundan böyle "Kurum" olarak anılacaktır.) ait olup 5846 sayılı Fikir ve Sanat Eserleri Kanunu ve 5237 sayılı 
          Türk Ceza Kanunu kapsamında korunmaktadır. Bu hakları ihlal eden kişiler, 5846 sayılı Fikir ve Sanat eserleri Kanunu ve 5237 sayılı Türk Ceza Kanununda 
          yer alan hukuki ve cezai yaptırımlara tabi olurlar. Kurum ihlalde bulunan ilgili hakkında yasal işlem başlatma hakkına sahiptir.
        </p>

        <p>
          Siteye erişim ve sitenin kullanımı aşağıdaki esas ve şartlara tabidir. Bu sitenin herhangi bir sayfasına girilmesi halinde aşağıda belirtilen 
          kullanım koşulları kabul edilmiş sayılır. Bu koşulların kabul edilmemesi durumunda siteye girilmemelidir.
        </p>

        <h2 className="section-title">Kullanım Koşulları</h2>

        <p>
          1-Bu sitedeki tüm materyallerin telif hakları Atatürk Kültür Merkezi Başkanlığına aittir. Kullanıcılar bilgi ve dokümanları herhangi bir ticari 
          ve çıkar amacı olmadan sadece kişisel bilgi edinmek amacıyla kullanabilir.
        </p>

        <p>
          2-Bu sitede yer alan tüm eserler Kurumun yazılı izni olmaksızın değiştirilemez, çoğaltılamaz, yayımlanamaz, dağıtılamaz, umuma iletilemez, başka bir lisana çevrilemez.
        </p>

        <p>
          3-Bu siteden yazılı ve/veya görsel nitelikte bilgi indirme, baskı alma ve internet sitelerinde kullanma ancak aşağıdaki koşullar dâhilinde yapılabilir:
        </p>

        <div className="sub-conditions">
          <p>
            3.1. Sitede yer alan eserlerin kullanımı kişisel kullanım ve/veya bilgi edinme amacı ile sınırlıdır. Ancak bu kapsamda gerçekleştirilen çoğaltma fiilleri 
            hak sahibinin meşru menfaatlerine haklı bir sebep olmadan zarar veremez ya da eserden normal yararlanmaya aykırı olamaz, ticari amaçla kullanılamaz.
          </p>

          <p>
            3.2. Sitedeki yazılı veya görsel materyal hiç bir şekilde değiştirilemez, telif hakkı ibareleri silinerek kullanılamaz.
          </p>

          <p>
            3.3. Sitede yer alan eserlerin bütünü veya bir kısmı değiştirilerek veya başka bir suretle diğer bir internet sitesinde izinsiz olarak kullanılamaz.
          </p>

          <p>
            3.4. Bu sitedeki veriler ancak ticari olmayan, bilgi alma amaçlı ve kişisel kullanım için indirebilir veya yazdırılabilir.
          </p>

          <p>
            3.5. Bu sitedeki verileri herhangi bir ticari amaç olmadan üçüncü şahıslara onların kişisel bilgilendirilmeleri için, içeriğin Kurum tarafından sağlandığını, 
            bu kayıt ve şartların onlara da uygulandığını ve bunlara uymak zorunda olduklarını belirtmek şartıyla gönderilebilir.
          </p>
        </div>

        <p>
          4-Kurum sitenin 24 saat erişilebilir olmasını sağlamaktadır. Ancak değişik sebeplerle sitenin erişilebilir olmamasından sorumlu değildir. 
          Siteye erişim, herhangi bir duyuru yapılmaksızın geçici veya sürekli olarak durdurulabilir. Sitede yer alan tüm bilgiler önceden haber verilmeksizin değiştirilebilir. 
          Kurum dilediği zaman, sitenin herhangi bir bölümünü iptal edebilir, haber vermeksizin sitedeki bazı özellikleri veya bilgileri değiştirebilir veya sitenin bazı bölümlerine erişimi sınırlandırabilir.
        </p>

        <p className="note">
          (Kurum bu yasal uyarıda yer alan tüm koşulları ve hükümleri önceden bir ihbara gerek kalmaksızın değiştirme ve güncelleme hakkını haizdir. 
          "Gizlilik politikası ve Sorumluluk reddi"ni düzenli olarak takip etmek, site kullanıcısının sorumluluğundadır. 
          Yapılan değişikliklerden sonra siteyi kullanmaya devam eden kişi, "Gizlilik politikası ve Sorumluluk reddi"ndeki değişiklikleri kabul etmiş sayılır.)
        </p>
      </div>
    </Container>
  );
};

export default GizlilikPolitikasi;

